import { DataModelBuilder, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { fromEnumAsString, toEnumFromStringOrNull } from '../../serialization/enum-utils.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export enum FeaturedTag {
    None = 'None',
    SponsoredBy = 'SponsoredBy'
}

export class FeaturedTagComponent extends Component {
  static readonly TYPE_ID: string = '79b3c2967ed347d387da5bcf3755fb0d';

  public tag: FeaturedTag;

  constructor(
      tag: FeaturedTag | null = null,
  ) {
    super();

    this.tag = tag ?? FeaturedTag.None;
  }

  get $removable(): boolean {
    return true;
  }

  get $typeId(): string {
    return FeaturedTagComponent.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): FeaturedTagComponent {
    return new FeaturedTagComponent(
        toEnumFromStringOrNull(MapUtils.getOrNull<string>(map, 'tag'), FeaturedTag),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'tag': fromEnumAsString(this.tag),
    };
  }

  clone(): this {
    return new FeaturedTagComponent(
        this.tag,
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.tag === this.tag;
  }
}

export class FeaturedTagComponentBuilder extends DataModelBuilder<FeaturedTagComponent> {
  build(context: SerializationContext, map: SerializedData): FeaturedTagComponent {
    return FeaturedTagComponent.fromMap(context, map);
  }
}
